package com.tovtalk.domain.entity

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

/** One support contact from GET /app/contact-phones for "save to contacts" in app. */
@Serializable
data class ContactPhoneItem(
    @SerialName("name") val name: String,
    @SerialName("phone") val phone: String,
)
